<template>
  <div class="row transaction">
    <!-- <div class="spinner-grow" role="status" v-if="loading === true"></div> -->

    <div class="p-4 col-12">
      <router-link class="btn btn-info m-2" :to="`/dashboard/merchants`">
        Back to Merchants
      </router-link>
    </div>

    <div class="col-12">
      <card class="card-plain">
        <div class="table-full-width table-responsive">
          <table class="table">
            <thead class="thead-dark">
              <tr>
                <th scope="col" class="text-center">S/N</th>

                <th scope="col" class="text-center">Merchant Name</th>
                <th scope="col" class="text-center">Business Name</th>
                <th scope="col" class="text-center">Institution Name</th>
                <th scope="col" class="text-center">Terminal ID</th>
                <th scope="col" class="text-center">Terminal ID 1</th>
                <th scope="col" class="text-center">Merchant ID</th>
                <th scope="col" class="text-center">Terminal Type</th>

                <th scope="col" class="text-center">Serial Number</th>
                <th scope="col" class="text-center">Configuration Status</th>

                <th scope="col" class="text-center">Configuration Date</th>
                <th scope="col" class="text-center">Sales Officer</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading === true">
                <td colspan="100%" class="text-center">
                  <div>
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                </td>
              </tr>

              <tr v-else-if="terminals.length === 0 && loading === false">
                <td colspan="100%" class="text-center">
                  <div class="">
                    <div class="alert-icon">
                      <i class="fa fa-info-circle"></i>
                    </div>
                    <span>No Terminals Found</span>
                  </div>
                </td>
              </tr>

              <template>
                <tr v-for="(terminal, index) in terminals" :key="terminal._id">
                  <th class="text-center">{{ index + 1 }}</th>
                  <td class="text-center">
                    {{ terminal.tmsMerchantName || "" }}
                  </td>
                  <td class="text-center">
                    {{ terminal.tmsMerchantId.companyName }}
                  </td>
                  <td class="text-center">
                    {{ getInstitutionName(terminal.institutionId) }}
                  </td>
                  <td class="text-center">{{ terminal.terminalId }}</td>
                  <td class="text-center">{{ terminal.terminalId1 }}</td>
                  <td class="text-center">{{ terminal.terminalType }}</td>
                  <td class="text-center">{{ terminal.serialNo }}</td>
                  <td class="text-center text-uppercase">
                    <span
                      class="status"
                      :class="
                        terminal.forceConfig
                          ? 'status-disabled'
                          : 'status-enabled'
                      "
                    >
                      {{
                        terminal.forceConfig ? "NOT CONFIGURED" : "CONFIGURED"
                      }}</span
                    >
                  </td>

                  <td class="text-center">
                    {{ formatDate(terminal.configurationDate) || "--" }}
                  </td>
                  <td class="text-center">
                    {{ getSalesOfficerName(terminal.salesOfficerId) || "N/A" }}
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import axios from "../store/axios";
import moment from "moment";
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  components: {},
  data() {
    return {
      loading: false,
      error: false,
      terminals: [],
      errorMsg: "",
      moment,
      format: new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),

      allSalesOfficers: [],
    };
  },

  methods: {
    ...mapActions(["getMerchant"]),

    formatDate(date) {
      return moment(date).format("YYYY-MM-DD, hh:mm:ss");
    },

    async getSalesOfficers() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/external-request/user/get-all-users`,
        );
        this.allSalesOfficers = res.data.users;
      } catch (err) {
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Merchants",
          });
        }
      }
    },

    getSalesOfficerName(id) {
      const officer = this.allSalesOfficers.find(
        (officer) => officer._id === id,
      );
      if (!officer) return "";

      return officer.lastName
        ? `${officer.firstName} ${officer.lastName}`
        : officer.firstName;
    },

    async getAllInstitutions() {
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/auth/get-institutions`,
        );

        this.allInstitutions = res.data.institutions.docs;
      } catch (err) {
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Institutions",
          });
        }
      }
    },

    getInstitutionName(id) {
      const institution = this.allInstitutions.find(
        (institution) => institution._id === id,
      );
      if (!institution) return "";
      return institution ? institution.institutionName : "";
    },
  },

  async mounted() {
    try {
      this.loading = true;
      const res = await axios.get(
        `${process.env.VUE_APP_API_URL}/merchant/terminals/${this.$route.params.merchantId}`,
      );

      this.terminals = res.data.terminals;
    } catch (err) {
      console.log(err);
      this.error = true;
      this.errorMsg = "Unable to Fetch Agents";
    }
    this.loading = false;
    this.getSalesOfficers();
    this.getAllInstitutions();
  },
};
</script>
<style scoped>
.transaction {
  font-size: 12px;
}
th {
  font-size: 12px !important;
}
.spinner-grow {
  position: fixed;
}
#list {
  list-style-type: none;
}
</style>
